import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@/store/index';
import { StoreKey } from '@/configs/storeKeys';

export type TutorialStep = {
	slug: string;
	enabled: boolean;
};

export type PastTutorialSteps = number[];
export const initialPastTutorialSteps: PastTutorialSteps = [];

export const initialCurrentTutorialStep = 0;

export type TutorialSteps = TutorialStep[];
const tutorialSteps: TutorialSteps = [
	{
		slug: 'customBackground',
		enabled: true,
	},
	{
		slug: 'playgroundShape',
		enabled: true,
	},
	{
		slug: 'playgroundDimensions',
		enabled: false,
	},
	{
		slug: 'playgroundFillings',
		enabled: false,
	},
	{
		slug: 'addProductModule',
		enabled: false,
	},
	{
		slug: 'modulePositioning',
		enabled: false,
	},
	{
		slug: 'measurements',
		enabled: false,
	},
	{
		slug: 'cameraToggler',
		enabled: false,
	},
	{
		slug: 'screenshots',
		enabled: false,
	},
];

interface SliceState {
	isTutorialOpened: boolean;
	currentTutorialStep: number;
	pastTutorialSteps: PastTutorialSteps;
	tutorialSteps: TutorialSteps;
}

const initialState: SliceState = {
	isTutorialOpened: false,
	currentTutorialStep: initialCurrentTutorialStep,
	pastTutorialSteps: initialPastTutorialSteps,
	tutorialSteps: [...tutorialSteps],
};

export const tutorialSlice = createSlice({
	name: StoreKey.TUTORIAL,
	initialState,
	reducers: {
		setTutorialCurrentStep: (state, action: PayloadAction<number>) => {
			state.currentTutorialStep = action.payload;
		},
		resetTutorialSteps: (state) => {
			state.tutorialSteps = [...tutorialSteps];
		},
		enableTutorialStep: (
			state,
			{ payload }: PayloadAction<number | number[]>
		) => {
			if (Array.isArray(payload)) {
				payload.forEach((step) => {
					state.tutorialSteps[step].enabled = true;
				});
			} else state.tutorialSteps[payload].enabled = true;
		},
		setTutorialPastSteps: (
			state,
			action: PayloadAction<Partial<PastTutorialSteps>>
		) => {
			Object.assign(state.pastTutorialSteps, action.payload);
		},
		nextTutorialCurrentStep: (state) => {
			state.pastTutorialSteps.push(state.currentTutorialStep);
		},
		setTutorialOpened: (state, { payload }: PayloadAction<boolean>) => {
			state.isTutorialOpened = payload;
		},
		finishTutorial: (state) => {
			state.pastTutorialSteps = state.tutorialSteps.map((_, idx) => idx);
		},
	},
});

export const tutorialActions = tutorialSlice.actions;

export const selectTutorialState = (state: RootState) => state.tutorial;
export default tutorialSlice.reducer;
